import React from 'react';
import HeaderComponent from './HeaderComponent';
import FooterComponent from './FooterComponent';
import CategoriesTreeViewContentComponent from './CategoriesTreeViewContentComponent';

class CategoriesTreeViewComponent extends React.Component {
    render() {
        return(
            <div className="main-panel">
                <CategoriesTreeViewContentComponent location={this.props.location}/>
                <FooterComponent/>
            </div>
        );
    }
}

export default CategoriesTreeViewComponent;